import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Location from './components/Location';
import Membership from './components/Membership';
import PersonalTraining from './components/PersonalTraining';
import ShopSection from './components/ShopSection';
import Footer from './components/Footer';

const App = () => {
  return (
    <>
      <Navbar />
      <Hero />
      <Location />
      <Membership />
      <PersonalTraining />
      <ShopSection />
      <Footer />
    </>
  );
}

export default App;
